export default "__VITE_ASSET__CxC7mC0s__"